import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "checked", "name", "required", "id"]

import { ref } from "vue";
import FormLabel from "../form-elements/includes/FormLabel.vue";
import FormErrors from "../form-elements/includes/FormErrors.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Radio',
  props: {
    id: {
        default: null,
        required: true,
        type: String
    },
    type: {
        default: 'text',
        required: false,
        type: String
    },
    required: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        required: true,
    },
    labelClassName: {
        type: String,
        required: false,
        default: null
    },
    inputClassName: {
        type: String,
        required: false,
        default: null
    },
    name: {
        type: String,
        required: true,
    },
    value: {
        type: String,
        required: false,
        default: ""
    },
    checked: {
        type: Boolean,
        required: false,
        default: false
    },
    className: {
        type: String,
        required: false,
        default: null
    }
},
  emits: ['update:checked'],
  setup(__props, { emit }) {

const props = __props;

// @ts-ignore



const errors = [];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-check form-check--line-radio js-form-validation__group", __props.className])
  }, [
    _createVNode(FormLabel, {
      label: __props.label,
      id: __props.id,
      required: __props.required,
      class: _normalizeClass(__props.labelClassName)
    }, null, 8, ["label", "id", "required", "class"]),
    _createElementVNode("input", {
      class: _normalizeClass(["form-check-input", __props.inputClassName]),
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:checked', $event.target.checked))),
      value: __props.value,
      checked: __props.checked,
      type: "radio",
      name: __props.name,
      required: __props.required,
      id: __props.id
    }, null, 42, _hoisted_1),
    _createVNode(FormErrors, { errors: errors })
  ], 2))
}
}

})